/** Spawn short-lived DOM ember shards that fly up from the crater on eruption. */
export function spawnEmbers(host: HTMLElement, count = 28): void {
  for (let i = 0; i < count; i++) {
    const e = document.createElement("i");
    e.style.position = "absolute";
    e.style.width = "4px";
    e.style.height = "4px";
    e.style.borderRadius = "50%";
    e.style.background = "var(--lava)";
    e.style.boxShadow = "0 0 14px var(--lava)";
    e.style.left = "50%";
    e.style.top = "52%";
    e.style.pointerEvents = "none";
    e.style.setProperty("--ex", `${Math.random() * 260 - 130}px`);
    e.style.setProperty("--ey", `${-Math.random() * 310 - 90}px`);
    const dur = 0.9 + Math.random() * 0.8;
    e.style.animation = `ng-ember ${dur}s ease-out forwards`;
    host.appendChild(e);
    e.addEventListener("animationend", () => e.remove());
  }
}
